// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3xNnB","container":"styles_container__Dh0f1","title":"styles_title__v6XtH","wrapper":"styles_wrapper__3oFNF","answer":"styles_answer__2CV9l"};